<div fxLayout="row" fxLayoutAlign="start center">
  <div class="alert-modal" fxLayout="column">
    <div class="title">
      <dgx-components-icon
        [size]="'sm'"
        [name]="'fa-light fa-file'"
      ></dgx-components-icon>
      <h4>Your documents are currently unavailable</h4>
    </div>

    <div class="content">
      <div class="top">
        If you purchased your plan under 24 hours ago, your documents might not
        have been added yet. Please come back later.
      </div>
      <div class="middle">
        You can also receive them by selecting ‘Email my plan documents’.
      </div>
      <div class="bottom">
        For anything else, you can see our
        <a (click)="handleHelpAndFaqClick()">help and advice</a>.
      </div>
    </div>

    <div class="options">
      <dgx-components-button
        [variant]="'primary'"
        class="mt-6"
        (clicked)="handleClose()"
      >
        Close
      </dgx-components-button>
    </div>

    <div class="close-icon">
      <dgx-components-icon name="xmark" size="lg" (click)="handleClose()">
      </dgx-components-icon>
    </div>
  </div>
</div>
